import { getExplorationCellsByTab } from '@/core/exploration';
import { Exploration } from '@/explore/types';

export const getCellsForExplorationOutline = (exploration: Exploration, tabId?: string | null) => {
  const cells =
    tabId !== undefined && tabId !== null
      ? getExplorationCellsByTab(exploration, tabId)
      : exploration.view.cells;
  return cells.filter((cell) => 'title' in cell || cell.kind === 'text');
};
